import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export const useFiltersStore = create(
  persist(
    (set) => ({
      tipoFactura: null,
      estadoFactura: { id: null, desc: 'Pendiente' },
      razonSocial: '',
      importeDesde: '',
      importeHasta: '',
      fechaDesde: '',
      fechaHasta: '',
      sector: null,
      appliedFilters: {},
      searchTerm: '',
      defaultsEnabled: true,
      setTipoFactura: (payload) => set({ tipoFactura: payload }),
      setEstadoFactura: (payload) => set({ estadoFactura: payload }),
      setRazonSocial: (valor) => set({ razonSocial: valor }),
      setImporteDesde: (valor) => set({ importeDesde: valor }),
      setImporteHasta: (valor) => set({ importeHasta: valor }),
      setFechaDesde: (valor) => set({ fechaDesde: valor }),
      setFechaHasta: (valor) => set({ fechaHasta: valor }),
      resetFilters: () => set({ tipoFactura: { id: null, desc: '' }, estadoFactura: { id: null, desc: '' }, razonSocial: '', importeDesde: '', importeHasta: '', fechaDesde: '', fechaHasta: '' }),
      setSector: (payload) => set({ sector: payload }),
      setAppliedFilters: (filters) => set({ appliedFilters: filters || {} }),
      setSearchTerm: (valor) => set({ searchTerm: valor || '' }),
      setDefaultsEnabled: (valor) => set({ defaultsEnabled: Boolean(valor) }),
      getDefaultFilters: () => {
        const oneYearAgo = new Date();
        oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
        return {
          estado: 'Pendiente'
        };
      },
      resetToDefault: () => {
        const defaultFilters = {
          estado: 'Pendiente'
        };
        set({ 
          appliedFilters: defaultFilters, 
          searchTerm: '', 
          defaultsEnabled: true 
        });
        // Eliminar la bandera para que al volver aplique Pendiente
        sessionStorage.removeItem('compras_filters_visible');
      },
      clearPersisted: () => set({ appliedFilters: {}, searchTerm: '', defaultsEnabled: false })
    }),
    {
      name: 'compras_filters_store',
      storage: createJSONStorage(() => sessionStorage),
      partialize: (s) => ({
        tipoFactura: s.tipoFactura,
        estadoFactura: s.estadoFactura,
        razonSocial: s.razonSocial,
        importeDesde: s.importeDesde,
        importeHasta: s.importeHasta,
        fechaDesde: s.fechaDesde,
        fechaHasta: s.fechaHasta,
        sector: s.sector,
        appliedFilters: s.appliedFilters,
        searchTerm: s.searchTerm,
        defaultsEnabled: s.defaultsEnabled
      })
    }
  )
);
